/**
 * @generated SignedSource<<6e80844288f150283929ff299a30b08d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateSourceTagInput = {
  clientMutationId?: string | null;
  sourceTagId: string;
  sourceId: string;
  key?: string | null;
  value?: string | null;
};
export type SourceTagReferenceModal_UpdateMutation$variables = {
  input: UpdateSourceTagInput;
};
export type SourceTagReferenceModal_UpdateMutationVariables = SourceTagReferenceModal_UpdateMutation$variables;
export type SourceTagReferenceModal_UpdateMutation$data = {
  readonly updateSourceTag: {
    readonly sourceTag: {
      readonly id: string;
      readonly key: string | null;
      readonly value: string | null;
      readonly source: {
        readonly id: string;
        readonly name: string;
      };
      readonly pageUrl: string;
    } | null;
  } | null;
};
export type SourceTagReferenceModal_UpdateMutationResponse = SourceTagReferenceModal_UpdateMutation$data;
export type SourceTagReferenceModal_UpdateMutation = {
  variables: SourceTagReferenceModal_UpdateMutationVariables;
  response: SourceTagReferenceModal_UpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSourceTagPayload",
    "kind": "LinkedField",
    "name": "updateSourceTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourceTag",
        "kind": "LinkedField",
        "name": "sourceTag",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Source",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pageUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SourceTagReferenceModal_UpdateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SourceTagReferenceModal_UpdateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ad1655d765e329b879985b1ba3cc7ad9",
    "id": null,
    "metadata": {},
    "name": "SourceTagReferenceModal_UpdateMutation",
    "operationKind": "mutation",
    "text": "mutation SourceTagReferenceModal_UpdateMutation(\n  $input: UpdateSourceTagInput!\n) {\n  updateSourceTag(input: $input) {\n    sourceTag {\n      id\n      key\n      value\n      source {\n        id\n        name\n      }\n      pageUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7040582e41cb87e5e00068d18b9cc86b";

export default node;
